import { EnvironmentProviders, makeEnvironmentProviders } from '@angular/core';

import { CLIENT_LOGGER_API_SENDER } from '@efficiently/client-core-logger';

import { ClientLogApiSenderService } from './repositories';

/**
 * Binds the client logger's `CLIENT_LOGGER_API_SENDER` contract to the GraphQL
 * sender. Call it next to `provideClientLogger()` in an app's config: the core
 * logger owns the pipeline and the contract, this lib owns the transport, so the
 * app is what composes the two.
 */
export function provideClientLogsDataAccess(): EnvironmentProviders {
	return makeEnvironmentProviders([
		ClientLogApiSenderService,
		{
			provide: CLIENT_LOGGER_API_SENDER,
			useExisting: ClientLogApiSenderService,
		},
	]);
}
